import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-common-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss'],
  standalone: true,
  imports: [NgIf, ModalComponent],
})
export class ModalConfirmComponent {
  @ViewChild('modal')
  modal!: ModalComponent;

  @Input()
  title?: string = $localize`Confirmation`;
  @Input()
  message: string = $localize`Are you sure you want to perform this action?`;
  @Input()
  confirmText?: string = $localize`Confirm`;
  @Input()
  hasCancel?: boolean = true;

  @Input() confirmColor?: 'primary' | 'secondary' | 'red' | 'green' | 'dark' = 'primary';

  @Output()
  confirm: EventEmitter<void> = new EventEmitter<void>();

  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  protected onConfirm() {
    this.confirm.emit();
  }

  open() {
    this.modal.open();
  }

  close() {
    this.modal.close();
    this.cancel.emit();
  }
}
